import { Tier } from "@/types";
import clsx from "clsx";
import { isEmpty } from "lodash";
import { FC } from "react";

type TierItemProps = {
  tier: Tier;
  selected?: boolean;
  hideIcon?: boolean;
  onClick: () => void;
};
export const TierItem: FC<TierItemProps> = ({
  tier: { id, name, benefits, items, price, off },
  selected = false,
  hideIcon = false,
  onClick = () => null,
}) => {
  return (
    <div className={clsx("btn-tier", { active: selected })} onClick={onClick}>
      <div className="flex items-center">
        <div className="name flex items-center gap-1">
          <div
            className={clsx("icon-wrapper relative w-[26px] h-[26px]", {
              hidden: hideIcon,
            })}
          >
            <svg
              className="icon--selected"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12.9997"
                cy="13.0009"
                r="11.2667"
                fill="#D6FDFF"
                stroke="#2EC6CC"
                strokeWidth="1.3"
              />
              <circle cx="12.9998" cy="13" r="5.2" fill="#1A1A1A" />
            </svg>

            <svg
              className="icon"
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12.9997"
                cy="12.9996"
                r="11.2667"
                fill="white"
                stroke="#CBD5E1"
                strokeWidth="1.3"
              />
            </svg>
          </div>
          {name}
        </div>

        {!!off && (
          <div className="ml-auto p-1.5 rounded bg-secondary text-[#17181D] text-xs leading-none">
            ${off.toLocaleString()} Off
          </div>
        )}

        <div className="ml-auto font-black text-base xl:text-2xl text-white leading-5 inline-flex items-center">
          ${price.toLocaleString()}
          <span className="text-sm text-[#EBEBEB] font-bold leading-5">
            &nbsp;yr
          </span>
        </div>
      </div>

      {(!isEmpty(benefits) || !isEmpty(items)) && (
        <>
          <div className="w-full border-b border-[#5A6969]" />
        </>
      )}

      {isEmpty(items) ? (
        !!benefits?.length && (
          <div className="flex flex-col gap-4">
            {benefits.map((benefit) => (
              <div key={benefit} className="benefit-item">
                <span className="icon mt-1">
                  <svg
                    width="10"
                    height="8"
                    viewBox="0 0 10 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M3.39413 5.88295L8.61113 0.666016L9.65867 1.71355L3.39413 7.97808L0 4.58395L1.04757 3.53642L3.39413 5.88295Z"
                    />
                  </svg>
                </span>
                {benefit}
              </div>
            ))}
          </div>
        )
      ) : (
        <div className="flex flex-col gap-5">
          {Object.values(items).map(({ id, name, benefits }, idx) => (
            <div
              className={clsx({ "border-t border-[#54616B] pt-5": idx > 0 })}
              key={id}
            >
              <div className="text-white text-lg font-bold leadning-none mb-3">
                {name}
              </div>

              <div className="flex flex-col gap-4">
                {benefits.map((benefit) => (
                  <div key={benefit} className="benefit-item">
                    <span className="icon mt-1">
                      <svg
                        width="10"
                        height="8"
                        viewBox="0 0 10 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.39413 5.88295L8.61113 0.666016L9.65867 1.71355L3.39413 7.97808L0 4.58395L1.04757 3.53642L3.39413 5.88295Z"
                        />
                      </svg>
                    </span>
                    {benefit}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
